<template>
  <div v-if="weight" class="weight-estimate" :class="{ 'is-large': large }" :title="explanation">
    <span class="weight-label">Est. weight</span>
    <span class="weight-value">&asymp;{{ kg(weight.grams) }} kg</span>
    <span class="weight-range">{{ kg(weight.low) }}&ndash;{{ kg(weight.high) }} kg<template v-if="weight.missing.length"> · excl. {{ weight.missing.length }} part{{ weight.missing.length > 1 ? 's' : '' }}</template></span>
  </div>
</template>

<script>
  import { kg, SMALL_PARTS } from '@/utils/weight';

  export default {
    props: {
      weight: Object,
      large: Boolean
    },
    computed: {
      explanation() {
        if ( !this.weight ) return '';
        const missing = this.weight.missing.length ? ` Not included (no published weight): ${ this.weight.missing.join(', ') }.` : '';
        return `Sum of manufacturer-claimed weights for the selected parts plus ${ SMALL_PARTS.grams } g of small parts `
          + `(bar tape, headset, thru-axles, seat clamp, sealant).${ this.weight.pedals ? '' : ' Pedals not included.' } Real weight varies with frame size.${ missing }`;
      }
    },
    methods: { kg }
  }
</script>

<style scoped>
.weight-estimate { display: flex; flex-direction: column; align-items: flex-end; line-height: 1.15; color: var(--builder-ink, #252c22); cursor: help; }
.weight-label { font-size: .6rem; letter-spacing: .04em; text-transform: uppercase; color: #697062; }
.weight-value { font-size: 22px; font-weight: 600; letter-spacing: -.02em; font-variant-numeric: tabular-nums; white-space: nowrap; }
.weight-range { font-size: 11px; color: #697062; font-variant-numeric: tabular-nums; white-space: nowrap; }
.weight-estimate.is-large { align-items: flex-start; }
.weight-estimate.is-large .weight-value { font-size: 30px; }
@media (max-width: 540px) {
  .weight-value { font-size: 17px; }
  .weight-range { display: none; }
}
</style>
